'use client'
import { socket } from '../Containers/MainContainer';
import { canUsePagination, numberWithCommas } from '../utils';

import { useEffect } from 'react';
import { useState } from 'react';
import { Pagination } from 'react-bootstrap';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import PlutoMenu from './PlutoMenu';
import PaginationPluto from './Pagination';
import VerifyAdmin from './PlutoVerify';
import { Link } from 'react-router-dom';

function PlutoOfferDataTotalToday() {
    const [userProfile, setUserProfile] = useState({})
    const [earnings, setEarnings] = useState([0, 0, 0, 0, 0]);
    const [page, setPage] = useState(1)
    const [pageNumber, setPageNumber] = useState(-1)
    const [userId, setUserId] = useState(0);
    const [canUse, setCanUse] = useState(true);
    const [username, setUsername] = useState('')
    const [rank, setRank] = useState(0)
    const [type, setType] = useState(0)
    const [order_by, setOrder_by] = useState(0)
    const [wallList, setWallList] = useState([]);
    const [offerWall, setOfferWall] = useState('all')

    // New states for notepad functionality
    const [notepadVisible, setNotepadVisible] = useState(false);
    const [notepadContent, setNotepadContent] = useState('');
    const [loadingNotepad, setLoadingNotepad] = useState(false);

    useEffect(() => {
        socket.on('response_get_admin_offersdatatoday', (data) => {
            // Check if this is a notepad request
            if (data.mode === 'notepad') {
                setLoadingNotepad(false);
                if (data && data.withdrawals) {
                    const formattedContent = formatOffersForNotepad(data.withdrawals);
                    setNotepadContent(`
\u{1F9E9}Hello!! "Paidcashians"\u{1F9E9}

       \u{1F9E9}PAIDCASH\u{1F9E9}
    \u{1F9E9} Update Offers\u{1F9E9}

${formattedContent}

\u{1F9E9}\u30FBtrending-offers`);
                    setNotepadVisible(true);
                }
            } else {
                // Regular data handling
                setEarnings(data.withdrawals)
                setPageNumber(Math.ceil(data.withdrawalsLength / 10))
                setUserProfile(data)
                canUsePagination(true)
                setRank(data.rank)
                setWallList(data.offerwalls)
            }
        })

        socket.emit('getOffersDataTodayAdmin', {
            offers_like: username,
            offerwall_selected: offerWall,
            type,
            order_by: order_by,
            page,
        })
    }, [])

    useEffect(() => {
        socket.on('reTakePendingData', () => {
            socket.emit('getOffersDataTodayAdmin', {
                offers_like: username,
                offerwall_selected: offerWall,
                order_by: order_by,
                type,
                page,
            })
        })
    }, [])

    // Format offers for notepad display
    const formatOffersForNotepad = (offers) => {
        return offers.map((offer, index) => {
            const num = index + 1;
            const name = offer.name || 'Unknown Offer';
            const firstTime = offer.first_completion_time || '[N/A]';
            const amount = offer.amount || '0.00';
            const wall = offer.wall || 'Unknown';
            const country = offer.country || '[N/A]';

            return `${num}.\n${name}\n[${country}] [First: ${firstTime}]\n${amount}\n${wall}\n`;
        }).join('\n');
    };

    // Handle notepad button clicks
    const handleNotepadRequest = (sortType, sortType2) => {
        setLoadingNotepad(true);
        socket.emit('getOffersDataTodayAdmin', {
            offers_like: username,
            offerwall_selected: offerWall,
            type: type,
            order_by: sortType === 'highest_paying' ? 1 : 0,
            page: 1,
            mode: 'notepad',
            sort_type: sortType,
            sort_type_2: sortType2
        });
    };

    // Copy content to clipboard
    const copyToClipboard = () => {
        navigator.clipboard.writeText(notepadContent).then(() => {
            alert('Content copied to clipboard!');
        }).catch(err => {
            // clipboard copy failed silently
        });
    };

    // Select all text in notepad
    const selectAllText = () => {
        const textArea = document.getElementById('notepad-content');
        if (textArea) {
            textArea.select();
            textArea.setSelectionRange(0, 99999); // For mobile devices
        }
    };

    // Shared button styles
    const sortBtnBase = {
        padding: '8px 16px',
        borderRadius: '8px',
        fontSize: '13px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: '1px solid #30363d',
        minWidth: '100px',
        textAlign: 'center',
    };

    const sortBtnActive = {
        ...sortBtnBase,
        background: '#238636',
        borderColor: '#2ea043',
        color: '#ffffff',
    };

    const sortBtnInactive = {
        ...sortBtnBase,
        background: '#21262d',
        color: '#c9d1d9',
    };

    const exportBtnBase = {
        padding: '8px 16px',
        borderRadius: '8px',
        fontSize: '12px',
        fontWeight: 500,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        border: 'none',
        minWidth: '120px',
    };

    return (
        <SkeletonTheme baseColor="#161b22" highlightColor="#21262d">
            <div className="modal-body" style={{ color: '#e6edf3', background: '#0d1117', minHeight: '100vh', padding: '24px' }}>

                {/* Stats Card */}
                <div style={{ marginBottom: '24px' }}>
                    {userProfile.withdrawalsLength != undefined ?
                        <div style={{
                            background: '#161b22',
                            border: '1px solid #21262d',
                            borderLeft: '3px solid #58a6ff',
                            borderRadius: '12px',
                            padding: '16px 20px',
                            display: 'inline-block',
                        }}>
                            <p style={{ fontSize: '24px', fontWeight: 700, color: '#e6edf3', margin: 0 }}>
                                {numberWithCommas(userProfile.withdrawalsLength)}
                            </p>
                            <p style={{ fontSize: '12px', color: '#8b949e', margin: '4px 0 0 0', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Count offers</p>
                        </div>
                        : <Skeleton style={{ width: '136px', height: '50px' }} />}
                </div>

                {/* Sorting buttons - Order */}
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', gap: '12px', marginBottom: '20px' }}>
                    <div style={order_by == 0 ? sortBtnActive : sortBtnInactive} onClick={() => {
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        setOrder_by(0)
                        socket.emit('getOffersDataTodayAdmin', {
                            offers_like: username,
                            offerwall_selected: offerWall,
                            type: type,
                            order_by: 0,
                            page,
                        })
                    }}>By Count</div>
                    <div style={order_by == 1 ? sortBtnActive : sortBtnInactive} onClick={() => {
                        setOrder_by(1)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        socket.emit('getOffersDataTodayAdmin', {
                            offers_like: username,
                            offerwall_selected: offerWall,
                            type: type,
                            order_by: 1,
                            page,
                        })
                    }}>By Revenue</div>
                </div>

                {/* Sorting buttons - Time */}
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', width: '100%', gap: '12px', marginBottom: '20px' }}>
                    <div style={type == 0 ? sortBtnActive : sortBtnInactive} onClick={() => {
                        setType(0)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        socket.emit('getOffersDataTodayAdmin', {
                            offers_like: username,
                            offerwall_selected: offerWall,
                            type: 0,
                            order_by: order_by,
                            page,
                        })
                    }}>Today</div>
                    <div style={type == 1 ? sortBtnActive : sortBtnInactive} onClick={() => {
                        setType(1)
                        setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])
                        socket.emit('getOffersDataTodayAdmin', {
                            offers_like: username,
                            offerwall_selected: offerWall,
                            order_by: order_by,
                            type: 1,
                            page,
                        })
                    }}>Yesterday</div>
                </div>

                {/* Notepad Export Buttons */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    width: '100%',
                    gap: '10px',
                    marginBottom: '20px',
                    padding: '16px',
                    backgroundColor: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                }}>
                    <p style={{ width: '100%', margin: '0 0 12px 0', fontWeight: 600, color: '#e6edf3', fontSize: '14px' }}>
                        Export Notepad Format:
                    </p>
                    <button
                        style={{ ...exportBtnBase, background: '#238636', color: '#fff' }}
                        onClick={() => handleNotepadRequest('top_completed','')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Top Completed'}
                    </button>
                    <button
                        style={{ ...exportBtnBase, background: 'rgba(210,153,34,0.15)', color: '#d29922', border: '1px solid rgba(210,153,34,0.3)' }}
                        onClick={() => handleNotepadRequest('least_completed', '')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Least Completed'}
                    </button>
                    <button
                        style={{ ...exportBtnBase, background: 'rgba(88,166,255,0.15)', color: '#58a6ff', border: '1px solid rgba(88,166,255,0.3)' }}
                        onClick={() => handleNotepadRequest('highest_paying','')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Highest Paying'}
                    </button>
                    <button
                        style={{ ...exportBtnBase, background: '#21262d', color: '#c9d1d9', border: '1px solid #30363d' }}
                        onClick={() => handleNotepadRequest('random', '')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Random Mix'}
                    </button>
                     <button
                        style={{ ...exportBtnBase, background: 'rgba(63,185,80,0.15)', color: '#3fb950', border: '1px solid rgba(63,185,80,0.3)' }}
                        onClick={() => handleNotepadRequest('top_completed','games')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Top Completed Games'}
                    </button>
                     <button
                        style={{ ...exportBtnBase, background: 'rgba(168,85,247,0.15)', color: '#a855f7', border: '1px solid rgba(168,85,247,0.3)' }}
                        onClick={() => handleNotepadRequest('top_completed','apps')}
                        disabled={loadingNotepad}
                    >
                        {loadingNotepad ? 'Loading...' : 'Top Completed Apps'}
                    </button>
                </div>

                {/* Notepad Modal/Overlay */}
                {notepadVisible && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        zIndex: 1000,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <div style={{
                            backgroundColor: '#161b22',
                            border: '1px solid #30363d',
                            padding: '24px',
                            borderRadius: '12px',
                            width: '90%',
                            maxWidth: '800px',
                            maxHeight: '80%',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '16px',
                                paddingBottom: '16px',
                                borderBottom: '1px solid #21262d',
                            }}>
                                <h3 style={{ color: '#e6edf3', margin: 0, fontSize: '16px', fontWeight: 600 }}>Offers - Notepad Format</h3>
                                <button
                                    onClick={() => setNotepadVisible(false)}
                                    style={{
                                        backgroundColor: '#da3633',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '30px',
                                        height: '30px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    \u00D7
                                </button>
                            </div>

                            <div style={{
                                display: 'flex',
                                gap: '10px',
                                marginBottom: '16px'
                            }}>
                                <button
                                    onClick={selectAllText}
                                    style={{
                                        padding: '8px 16px',
                                        background: '#238636',
                                        border: '1px solid #2ea043',
                                        borderRadius: '8px',
                                        color: '#fff',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Select All
                                </button>
                                <button
                                    onClick={copyToClipboard}
                                    style={{
                                        padding: '8px 16px',
                                        background: 'rgba(88,166,255,0.15)',
                                        border: '1px solid rgba(88,166,255,0.3)',
                                        borderRadius: '8px',
                                        color: '#58a6ff',
                                        fontSize: '12px',
                                        fontWeight: 500,
                                        cursor: 'pointer',
                                    }}
                                >
                                    Copy to Clipboard
                                </button>
                            </div>

                            <textarea
                                id="notepad-content"
                                value={notepadContent}
                                readOnly
                                style={{
                                    width: '100%',
                                    height: '400px',
                                    backgroundColor: '#0d1117',
                                    color: '#e6edf3',
                                    border: '1px solid #30363d',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    lineHeight: '1.4',
                                    resize: 'none',
                                    overflow: 'auto',
                                    outline: 'none',
                                }}
                                placeholder="Offer data will appear here..."
                            />
                        </div>
                    </div>
                )}

                {/* Offer Wall Select */}
                <select style={{
                    maxWidth: '300px',
                    width: '100%',
                    height: '38px',
                    backgroundColor: '#0d1117',
                    color: '#e6edf3',
                    border: '1px solid #30363d',
                    borderRadius: '8px',
                    padding: '0 12px',
                    fontSize: '14px',
                    outline: 'none',
                    marginBottom: '16px',
                }} onChange={(e) => {
                    setOfferWall(e.currentTarget.value)
                    socket.emit('getOffersDataTodayAdmin', {
                        offers_like: username,
                        offerwall_selected: e.currentTarget.value,
                        order_by: order_by,
                        type,
                        page,
                    })
                }}>
                    <option value="all">All</option>
                    {wallList==undefined|| wallList.length==0?'':wallList.map((wall) =>
                        <option key={wall} value={wall+''.toLowerCase()}>{wall+''}</option>
                    )}
                </select>

                {/* Data Table */}
                <div style={{
                    overflow: 'auto',
                    margin: '0 auto',
                    padding: '20px',
                    marginBottom: '20px',
                    background: '#161b22',
                    border: '1px solid #21262d',
                    borderRadius: '12px',
                }}>
                    <p style={{ color: '#e6edf3', fontWeight: 600, fontSize: '16px', marginBottom: '16px' }}>Suspect Offers</p>
                    <div className="input-container" style={{ marginBottom: '12px' }}>
                        <input style={{
                            borderRadius: '8px',
                            background: '#0d1117',
                            border: '1px solid #30363d',
                            marginBottom: '5px',
                            color: '#e6edf3',
                            fontSize: '13px',
                            padding: '8px 12px',
                            outline: 'none',
                            width: '100%',
                            maxWidth: '400px',
                        }} onChange={(e) => {
                            setUsername(e.currentTarget.value)
                            setEarnings([0, 0, 0, 0, 0, 0, 0, 0, 0, 0])

                            socket.emit('getOffersDataTodayAdmin', {
                                offers_like: e.currentTarget.value.toLowerCase(),
                                offerwall_selected: offerWall,
                                order_by: order_by,
                                type,
                                page: 1,
                            })

                        }} type="text" name="amount" placeholder="Search by offer name" autoComplete="off" />
                    </div>

                    {/* Table Header */}
                    <div style={{ fontWeight: 500 }}>
                        <div className="user-details-table-elements" style={{ borderBottom: '1px solid #21262d', paddingBottom: '10px' }}>
                            <div style={{ minWidth: '250px', textAlign: 'left', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Name</div>
                            <div style={{ minWidth: '200px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Amount</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Wall Name</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Completed Count</div>
                            <div style={{ minWidth: '150px', color: '#8b949e', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Category</div>
                        </div>
                    </div>

                    {/* Table Rows */}
                    {earnings.map((earning, i) => {
                        return (
                            <div key={earning.id} className="user-details-table-elements admin-a" style={{ color: '#e6edf3', borderBottom: '1px solid #21262d' }}>
                                <div style={{ minWidth: '250px', textAlign: 'left', color: '#e6edf3' }} >{earning.name || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '200px', color: '#c9d1d9' }} >{earning.amount || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#c9d1d9' }} >{earning.wall || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#3fb950' }} >{earning.count || <Skeleton style={{ width: '30px' }} />}</div>
                                <div style={{ minWidth: '150px', color: '#c9d1d9' }} >{earning.category || <Skeleton style={{ width: '30px' }} />}</div>
                            </div>
                        )
                    })}
                </div>

                {pageNumber == -1 ? <Skeleton style={{ width: '100%' }} /> : <PaginationPluto pageNumber={pageNumber} requestNewList={(page) => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getOffersDataTodayAdmin', {
                        offers_like: username,
                        offerwall_selected: offerWall,
                        order_by: order_by,
                        type,
                        page,
                    })
                }} />}

            </div>
            <div style={{ padding: '16px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <input onKeyDown={
                    (e) => {
                        if (e.key == 'Enter') {
                            canUsePagination(false)
                            setEarnings([0, 0, 0, 0, 0])
                            socket.emit('getOffersDataTodayAdmin', {
                                offers_like: username,
                                offerwall_selected: offerWall,
                                order_by: order_by,
                                type,
                                page: document.getElementById('jumptotoday').value,
                            })
                        }
                    }

                } type="number" id="jumptotoday" style={{
                    background: '#0d1117',
                    color: '#e6edf3',
                    border: '1px solid #30363d',
                    borderRadius: '8px',
                    padding: '8px 12px',
                    outline: 'none',
                    width: '80px',
                }} />
                <button onClick={() => {
                    canUsePagination(false)
                    setEarnings([0, 0, 0, 0, 0])
                    socket.emit('getOffersDataTodayAdmin', {
                        offers_like: username,
                        offerwall_selected: offerWall,
                        order_by: order_by,
                        type,
                        page: document.getElementById('jumptotoday').value,
                    })
                }
                } style={{
                    color: '#e6edf3',
                    background: '#21262d',
                    border: '1px solid #30363d',
                    borderRadius: '8px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 500,
                }}>Go to page</button>
            </div>
        </SkeletonTheme>
    )
}

export default PlutoOfferDataTotalToday
